module.exports = __webpack_public_path__ + "img/hamochConfirm.ef0e00fb.png";